import { render, staticRenderFns } from "./complain-reply.vue?vue&type=template&id=cc792e02&scoped=true&"
import script from "./complain-reply.vue?vue&type=script&lang=js&"
export * from "./complain-reply.vue?vue&type=script&lang=js&"
import style0 from "./complain-reply.vue?vue&type=style&index=0&id=cc792e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc792e02",
  null
  
)

export default component.exports